"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGuardMedicalRecords = void 0;
const firestore_1 = require("firebase/firestore");
/**
 *
 * @param uid uid del paciente
 * @param assignationId assignationID del medicalRecord
 * @returns path al medicalRecord en la DB
 */
function getMedicalRecordsPath(uid, assignationId = false) {
    if (!assignationId)
        return `user/${uid}/medical_records`;
    else
        return `user/${uid}/medical_records/${assignationId}`;
}
/**
 * get appointments from guardia
 *
 * @param firestore instancia de la base de datos de Firestore
 * @param uid uid del usuario
 * @returns {Array<IMedicalRecordCompat>} array with all appointments
 */
async function getGuardMedicalRecords(firestore, uid) {
    let pendingAppointments;
    try {
        const path = getMedicalRecordsPath(uid, false);
        const guardAppointments = (0, firestore_1.query)((0, firestore_1.collection)(firestore, path), (0, firestore_1.where)("att_category", "==", "GUARDIA_RANDOM"));
        pendingAppointments = await (0, firestore_1.getDocs)(guardAppointments);
    }
    catch (err) {
        throw new Error(`db error ${err}`);
    }
    if (pendingAppointments.empty) {
        return [];
    }
    return pendingAppointments.docs.map((document) => document.data());
}
exports.getGuardMedicalRecords = getGuardMedicalRecords;
exports.default = getGuardMedicalRecords;
